module.exports = __webpack_public_path__ + "static/img/1072_small.0a3db01.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1072_small.png
// module id = MzEl
// module chunks = 1